import { render, staticRenderFns } from "./positionlist.vue?vue&type=template&id=1dfa0103&scoped=true&"
import script from "./positionlist.vue?vue&type=script&lang=js&"
export * from "./positionlist.vue?vue&type=script&lang=js&"
import style0 from "./positionlist.vue?vue&type=style&index=0&id=1dfa0103&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfa0103",
  null
  
)

export default component.exports